export default __webpack_public_path__ + "static/media/1.cdc50935.png";